import { Grid } from '@material-ui/core';
import React from 'react';
import Arrow from '../Icons/Arrow';

const Pagination = ({ classes, showPrev, showNext, onChangePage }) => {
  console.log('ShowNext', showNext);
  return (
    <div className={classes.pagination}>
      <Grid
        className={`${classes.previous} button ${
          !showPrev ? classes.disabled : ''
        }`}
        onClick={() => {
          if (showPrev) onChangePage(-1);
        }}
      >
        <Arrow /> Previous
      </Grid>
      <Grid
        className={`button ${!showNext ? classes.disabled : ''}`}
        onClick={() => {
          if (showNext) onChangePage(1);
        }}
      >
        Next
        <Arrow />
      </Grid>
    </div>
  );
};

export default Pagination;
